import { FC, ReactElement } from 'react'
import LoggedArea from '.'
import BreadCrumbs, { BreadCrumb } from '../../components/breadCrumbs'
import H2 from '../../components/h2'
import { ContainerDefault, TabHeader } from './style'

type TabItemsProps = {
  title?: string | ReactElement;
  subtitle?: string | ReactElement;
  info?: string;
  headerComponent?: string | ReactElement;
  navigationComponent?: ReactElement;
  breadcrumbs?: BreadCrumb[]
}

const Default: FC<TabItemsProps> = ({
  title,
  subtitle,
  info,
  headerComponent,
  navigationComponent,
  children,
  breadcrumbs
}): ReactElement => {
  return (
    <LoggedArea navigationComponent={navigationComponent}>
      <TabHeader>
        {breadcrumbs && <BreadCrumbs breadcrumbs={breadcrumbs} />}
        {title && <H2>{title}</H2>}
        {subtitle && <p>{subtitle}</p>}
        {info && (
          <p className='info'>{info}</p>
        )}
        {headerComponent}
      </TabHeader>
      <ContainerDefault>
        {children}
      </ContainerDefault>
    </LoggedArea>
  )
}

export default Default
